import {
    TERRITORY_CREDIT,
    TERRITORY_CREDIT_SUCCESS,
    TERRITORY_CREDIT_FAILURE,
    SAVE_TERRITORY_CREDIT,
    SAVE_TERRITORY_CREDIT_SUCCESS,
    SAVE_TERRITORY_CREDIT_FAILURE,
    RESET_SAVE_TERRITORY_CREDIT,
} from '../actions';

const initialState = {
    loading: false,
    territoryCreditData: [],
    saveTerritoryCreditData: null,
};

const territoryCreditReducer = (state = initialState, action) => {
    switch (action.type) {
        case TERRITORY_CREDIT:
            return {
                ...state,
                loading: true,
            };
        case TERRITORY_CREDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                territoryCreditData: action.payload,
            };
        case TERRITORY_CREDIT_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case SAVE_TERRITORY_CREDIT:
            return {
                ...state,
                loading: true,
            };
        case SAVE_TERRITORY_CREDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                saveTerritoryCreditData: action.payload,
            };
        case SAVE_TERRITORY_CREDIT_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case RESET_SAVE_TERRITORY_CREDIT:
            return {
                ...state,
                saveTerritoryCreditData: null,
            };
        default:
            return {
                ...state,
            };
    }
};

export default territoryCreditReducer;
